import React, { useState, createContext, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./auth";
const NavigationContext = createContext({});
const useNavigation = () => useContext(NavigationContext);

function NavigationProvider(props) {
  const [navigationData, setNavigationData] = useState({ currentPath: "" });

  return (
    <NavigationContext.Provider
      value={{ navigationData, setNavigationData }}
      {...props}
    />
  );
}

function withNavigationWatcher(Component, path) {
  const WrappedComponent = function (props) {
    const { setNavigationData } = useNavigation();
    const { user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
      setNavigationData((prev) => ({
        ...prev,
        currentPath: path,
      }));

      // 🔴 ROLE BASED ACCESS CONTROL
      if (!user) return;

      const role = user.userrole;
      const commonRoutes = [
        "/help-center",
        "/help-center/get-started",
        "/help-center/FAQs",
      ];

      const roleAccess = {
        company: [
          "/adminDashboard",
          "/ticket",
          "/client",
          "/client/Add-client",
          "/client/Edit-client",
          "/client/Assign-Projects",
          "/Developer",
          "/Developer/Add-Developer",
          "/Developer/Edit-Developer",
          "/Developer/Assign-Projects",
          "/projects",
          "/configuration",
          "/Reports",
          "/Log-Reports",
          "/CompanyProfile",

          ...commonRoutes,
        ],
        companyuser: [
          "/developerDashboard",
          "/ticket",
          "/Reports",
          "/Log-Reports",
          "/developer-configuration",
          "/Profile",
          ...commonRoutes,
        ],
        customer: [
          "/customerDashboard",
          "/ticket",
          "/contact",
          "/contact/Add-Contact",
          "/contact/Edit-Contact",
          "/client-configuration",
          "/CustomerProfile",
          ...commonRoutes,
        ],
        customercontact: [
          "/custContactDash",
          "/ticket",
          "/contact-configuration",
          "/CustomerContactProfile",
          ...commonRoutes,
        ],
      };

      const allowedRoutes = roleAccess[role] || [];

      //  Check if path is allowed
      const isAllowed = allowedRoutes.some((route) => path.startsWith(route));

      if (!isAllowed) {
        // 🔴 Redirect based on role
        if (role === "company") navigate("/adminDashboard");
        else if (role === "companyuser") navigate("/developerDashboard");
        else if (role === "customer") navigate("/customerDashboard");
        else if (role === "customercontact") navigate("/custContactDash");
      }
    }, [path, setNavigationData, user, navigate]);

    return <Component {...props} />;
  };
  return <WrappedComponent />;
}

export { NavigationProvider, useNavigation, withNavigationWatcher };
